import { useContext } from "react";
import docStore from "~/stores/document";
import { observer } from "mobx-react";
import styles from "./styles.module.scss";
import DocItem from "~/components/DocItem";
import DocListSkeleton from "~/components/DocItem/DocItemSkeleton";
import DocumentsContext from "./DocumentsContext";
import { useDataFetcher } from "~/pages/PersonalArea/common";

const LatestUploadedList = observer(() => {
  const { onDocumentClick } = useContext(DocumentsContext);
  const fetcher = useDataFetcher(true, docStore.loadLatestDocuments, {
    defaultSortBy: "-id",
  });

  return (
    <div className={styles.leftColContent}>
      <h4 className="pt-[24px] mb-[24px] text-xl font-semibold">Latest uploads</h4>
      {fetcher.loading && <DocListSkeleton />}
      {!!fetcher.items?.results &&
        fetcher.items.results.map((item) => {
          return <DocItem key={item.id} doc={item} onDocumentClick={() => onDocumentClick(item)} />;
        })}
    </div>
  );
});

export default LatestUploadedList;
